export enum GTM_EVENT_CATEGORY {
  DISTRIBUTION = 'DISTRIBUTION',
  DONATION = 'DONATION',
  EVENT_CLICKTHROUGH = 'EVENT_CLICKTHROUGH',
  FOOTER_NAVIGATION = 'FOOTER_NAVIGATION',
  GENERIC_CTA_CLICK = 'GENERIC_CTA_CLICK',
  HEADER_NAVIGATION = 'HEADER_NAVIGATION',
  LOCATION_ACTIONS = 'LOCATION_ACTIONS',
  NEWSLETTER = 'NEWSLETTER',
  PARTNER_CLICKTHROUGH = 'PARTNER_CLICKTHROUGH',
  QUERY_LOCATION = 'QUERY_LOCATION',
  RECIPE_CLICK = 'RECIPE_CLICK',
  SUPPORT_US = 'SUPPORT_US',
  VENDOR_CLICK = 'VENDOR_CLICK',
  VIDEO_CLICK = 'VIDEO_CLICK',
}
